export class ErrorInfo {
  constructor(
    public message: string,
    public code?: number,
    public extra?: any,
  ) {}

  static createNew(message: string): ErrorInfo;
  static createNew(message: string, code: number): ErrorInfo;
  static createNew(message: string, extra: any): ErrorInfo;
  static createNew(message: string, code?: number, extra?: any): ErrorInfo {
    return new ErrorInfo(message, code, extra);
  }
}
